<template>
  <div class="f-valueSlider">
    <div class="iCountUp">
      <p class="counterCaption">{{title}}</p>
      <ICountUp
        :startVal="startVal"
        :endVal="endVal"
        :decimals="decimals"
        :duration="duration"
        :options="options"
        @ready="onReady"/>
      <p class="counterCaption">{{subTitle}}</p>
    </div>
  </div>
</template>

<script type="text/babel">
  import ICountUp from 'vue-countup-v2'

  export default {
    name: 'ValueSlider',
    components: {
      ICountUp
    },
    props: {
      startCount: {
        type: String
      },
      endCount: {
        type: String
      },
      durationTime: {
        type: String
      },
      decrementVal: {
        type: String
      },
      counterMode: {
        type: String
      },
      title: {
        type: String
      },
      subTitle: {
        type: String
      }
    },
    data () {
      return {
        startVal: Number(this.startCount),
        endVal: Number(this.endCount) - Number(this.decrementVal || 0),
        decimals: 0,
        duration: Number(this.durationTime),
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        }
      }
    },
    methods: {
      onReady: function (instance) {
        switch (this.counterMode) {
          case 'fakeIncrementer':
            this.fakeIncrementer(instance)
            break
          default:
            return
        }
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      fakeIncrementer (instance) {
        const self = this
        let offset = this.getRandomInt(1, 10)
        setInterval(function () {
          if (self.endVal > self.endCount) return
          instance.update(self.endVal + offset)
          offset += self.getRandomInt(1, 10)
        }, self.getRandomInt(1000, 4000))
      }
    }
  }
</script>

<style scoped>
  .iCountUp {
    font-size: 5em;
    margin: 0;
    color: #c41c21;
  }

  .counterCaption {
    font-size: 20pt;
  }

  .f-valueSlider{
    background-color: #dadada;
    margin: 1pt solid black;
  }
</style>



// WEBPACK FOOTER //
// src/components/utilComponents/ValueSlider.vue